import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { renderContentBlocks } from './renderContentBlocks'

type BrowseScreenWrapperProps = {
  contentBlocks: MenuContentBlock[]
  collectionId?: string
}

export const BrowseScreenWrapper = ({ contentBlocks, collectionId }: BrowseScreenWrapperProps) => (
  <div data-testid="menu-experience-browse-screen">
    {renderContentBlocks(contentBlocks, { collectionId })}
  </div>
)
